import { CLOSENESS_MAX, CLOSENESS_MIN } from "../../lib/connectionDetails";

const DESCRIPTIONS = {
  1: "Barely know them",
  2: "Acquaintance",
  3: "Keep in touch",
  4: "Close",
  5: "Inner circle",
};

const STEPS = Array.from(
  { length: CLOSENESS_MAX - CLOSENESS_MIN + 1 },
  (_, index) => CLOSENESS_MIN + index
);

/** How close you are to this person, per context, as a segmented scale. */
export default function ClosenessPicker({ value, onChange, disabled = false }) {
  return (
    <div className="closeness">
      <p className="rail-label" id="closeness-label">Closeness</p>
      <div className="closeness-bar" role="radiogroup" aria-labelledby="closeness-label">
        {STEPS.map((step) => (
          <button
            key={step}
            type="button"
            role="radio"
            aria-checked={value === step}
            aria-label={`${step} — ${DESCRIPTIONS[step]}`}
            title={DESCRIPTIONS[step]}
            className={`closeness-segment${step <= value ? " is-filled" : ""}`}
            disabled={disabled}
            onClick={() => onChange?.(step)}
          >
            <span className="visually-hidden">{step}</span>
          </button>
        ))}
      </div>
      <p className="closeness-caption">{DESCRIPTIONS[value] || "Not set"}</p>
    </div>
  );
}
